import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons"

export const EllipsisV = (props) => {
  return <FontAwesomeIcon faIcon={faEllipsisV} {...props} />
}
